import React from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { copyToClipboard } from 'utils/helpers';

interface SocialAccountOnboardingSuccessModalProps {
    onboarding: {
        message: string;
        handle: string;
        profileUrl: string;
    } | null;
    closeSuccessModal: () => void;
}

const SocialAccountOnboardingSuccessModal: React.FC<SocialAccountOnboardingSuccessModalProps> = ({ onboarding, closeSuccessModal }) => {
    return (
        <Modal centered isOpen={!!onboarding} toggle={closeSuccessModal}>
            <ModalHeader toggle={closeSuccessModal}>Send Instagram DM</ModalHeader>
            <ModalBody>
                <p className="mb-2">
                    The message below has been copied to your clipboard. Open Instagram and paste it in a
                    DM to <strong>@{onboarding?.handle}</strong> to onboard them.
                </p>
                <div className="border rounded p-3 bg-light">
                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                        {onboarding?.message || '—'}
                    </p>
                </div>
            </ModalBody>
            <ModalFooter className="border-top py-2">
                <button
                    type="button"
                    className="theme-btn btn-primary-outlined"
                    onClick={() => {
                        if (onboarding?.message) {
                            copyToClipboard(onboarding.message, 'Message copied to clipboard');
                        }
                    }}
                    disabled={!onboarding?.message}
                >
                    <i className="ri-file-copy-line me-1" /> Copy Again
                </button>
                <button
                    type="button"
                    className="theme-btn btn-primary"
                    onClick={() => {
                        if (onboarding?.profileUrl && onboarding.profileUrl !== '#') {
                            window.open(onboarding.profileUrl, '_blank', 'noopener,noreferrer');
                        }
                    }}
                    disabled={!onboarding?.handle}
                >
                    Open Instagram & Send DM <i className="ri-instagram-line ms-1" />
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default SocialAccountOnboardingSuccessModal